import React from 'react'
import { useHistory } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconDelete } from '../../../../../../shared/icon/icon'
import { Form, FormSubmitBack, FormTextConfirm } from '../../../../../../shared/form/form'
import { FolderMenu } from '../../common/menu/node-actions'

export const NodeCategoryDelete = ({ grandParentURL, parentURL, nodeID, useApiForm, dataContext, section }) => {
  const history = useHistory()

  const apiForm = useApiForm()

  const handleMatch = async () => await apiForm.get(nodeID)

  const handleSubmit = async () => {
    await apiForm.delete(nodeID)
    await dataContext.reload()

    history.push(grandParentURL)
  }

  const HeaderMenu = () => <FolderMenu place="header" url={parentURL} nodeID={nodeID} section={section} />

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconDelete} text="delete" onMatch={handleMatch}>
        <CardFullHeightScrollY title={apiForm.form.name} HeaderMenu={HeaderMenu}>
          <div className="py-2">This is a destructive action</div>
          <Form onSubmit={handleSubmit}>
            <FormTextConfirm placeholder="delete" subtext="Type delete to confirm" confirmValue="delete" name="test" required autoFocus />
            <FormSubmitBack text="delete category" />
          </Form>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
